import { useQuery } from '@tanstack/react-query';
import type { Policy } from './interfaces';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/subsidy/base';

export const usePoliciesIndex = () => {
  const response = useQuery<{ policies: Policy[] }>({
    queryKey: [clientKeys.usePoliciesIndex],
    queryFn: () => falconClient.get(`${baseUrl}/policies`),
  });

  const policies = response.data?.policies || [];
  const hasOnlyOnePolicy = policies?.length === 1;
  const policy = hasOnlyOnePolicy ? policies?.[0] : null;

  return { policies, policy, hasOnlyOnePolicy, ...response };
};
